import { FelaCSSWithCustomSelectors, colors, transition } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSSWithCustomSelectors;
}

const styles = (isLoggedIn?: boolean): IStyles => ({
  wrapper: {
    height: '0',
    overflow: 'hidden',

    // react-sticky needs to be updated to latest version to refactor this
    '> div': {
      '> .sticky-brochure-request': {
        visibility: 'hidden',
        position: 'fixed',
        zIndex: 100,
        display: 'flex',
        alignItems: 'flex-end',
        flexDirection: 'column',
        left: 0,
        right: 0,
        top: 'auto !important',
        bottom: 0,
        overflow: 'hidden',
        backgroundColor: isLoggedIn ? colors.white : colors.transparent,
        transition: isLoggedIn ? undefined : `visibility ${transition.fast} ease-in-out`,
        pointerEvents: 'auto',

        '> div': {
          transition: `transform ${transition.fast} ease-in-out`,
          transform: 'translateY(100%)',
          pointerEvents: 'auto',
        },
      },

      '> .sticky-brochure-request.sticky-brochure-request-sticky': {
        visibility: 'visible',

        '> div': {
          transform: 'translateY(0)',
        },
      },
    },
  } as FelaCSSWithCustomSelectors,
});

export default styles;
